// price-list.service.ts
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

// export interface PriceList { id:number; university_name:string; fees:number; created_at?:string; updated_at?:string; }

@Injectable({ providedIn: 'root' })
export class PriceListService {
  private base = `${environment.Server_URL}/price-list`;

  constructor(private http: HttpClient) {}

  // GET /price-list?per_page=&page=
  getAll(): Observable<any> {
    return this.http.get<any>(`${this.base}`);
  }

  // GET /price-list/{id}
  getById(id: number): Observable<any> /* | Observable<PriceList> */ {
    return this.http.get<any>(`${this.base}/${id}`);
  }

  // POST /price-list
  create(payload: any /* | PriceList */): Observable<any> {
    return this.http.post<any>(this.base, payload);
  }

  // PATCH /price-list/{id}
  update(id: number, payload: FormData | any): Observable<any> {
  const isFormData = payload instanceof FormData;

  if (isFormData) {
    payload.append('_method', 'PUT'); // ✨ ده يخلي Laravel يفهم إن الريكوست update
    return this.http.post(`${this.base}/${id}`, payload);
  }

  return this.http.put(
    `${this.base}/${id}`,
    payload,
    { headers: { 'Content-Type': 'application/json' } }
  );
}

  // DELETE /price-list/{id}
  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.base}/${id}`);
  }

  // GET /price-list/search?q=&page=&per_page=
  search(q: string, page = 1, perPage = 10): Observable<any> {
    const params = new HttpParams()
      .set('q', q)
      .set('page', page)
      .set('per_page', perPage);
    return this.http.get<any>(`${this.base}/search`, { params });
  }
  getSARPrice() {
  return this.http.get<any>('https://api.exchangerate.host/latest?base=SAR&symbols=EGP');
}

}
